import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("path", {
  d: "M15.1746 10.1204C15.3843 9.94067 15.6999 9.96495 15.8796 10.1746C16.0593 10.3843 16.0351 10.6999 15.8254 10.8796L12.3254 13.8796C12.1382 14.0401 11.8619 14.0401 11.6746 13.8796L8.17461 10.8796C7.96495 10.6999 7.94067 10.3843 8.12038 10.1746C8.30009 9.96495 8.61574 9.94067 8.8254 10.1204L12 12.8415L15.1746 10.1204Z",
  fill: "#999999"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tr_node = _resolveComponent("tr-node")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("tr", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.headers, (header, index) => {
        return (_openBlock(), _createBlock("td", {
          key: header.value,
          style: {
        position: header.position,
        left: header.left,
        background: header.background,
        zIndex: header.zIndex,
        borderRight: header.borderRight,
      },
          class: "relative break-all"
        }, [
          _renderSlot(_ctx.$slots, header.value, { item: $props.item }, () => [
            _createTextVNode(_toDisplayString($props.item.value) + " ", 1),
            (index === 0)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["flex", `ml-${index === 0 ? $props.item.child_lv * 2 : 0}`]
                }, [
                  (_openBlock(), _createBlock("svg", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleRow($props.item, 'show_child', $props.dataIndex))),
                    style: {
              opacity: $props.item.childs && $props.item.childs.length > 0 ? 1 : 0,
              transform: !$props.item.show_child ? 'rotate(0deg)' : 'rotate(180deg)',
              cursor:
                $props.item.childs && $props.item.childs.length > 0 ? 'pointer' : 'default',
            },
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _hoisted_1
                  ], 4)),
                  _createTextVNode(" " + _toDisplayString($props.item[header.value]), 1)
                ], 2))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  onClick: ($event: any) => ($setup.handleChangeValue($props.item, header.value, $props.dataIndex)),
                  innerHTML: $setup.iconValue[$props.item[header.value]] || $setup.iconValue[3],
                  class: "flex justify-center p-2 cursor-pointer"
                }, null, 8, ["onClick", "innerHTML"]))
          ])
        ], 4))
      }), 128))
    ]),
    ($props.item.childs && $props.item.childs.length > 0 && $props.item.show_child)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList($props.item.childs, (item_child) => {
          return (_openBlock(), _createBlock(_component_tr_node, {
            onHiddenChild: $setup.toggleRow,
            onChangeValue: $setup.handleChangeValue,
            dataIndex: $props.dataIndex,
            child: true,
            item: item_child,
            key: item_child.id,
            headers: $props.headers
          }, null, 8, ["onHiddenChild", "onChangeValue", "dataIndex", "item", "headers"]))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}